import React, { useEffect, useState } from 'react';
import {
  BaseAddonCategoryXlsType,
  BaseAddonCategoryFormFieldType,
  BaseAddonCategoryFormType
} from 'utils/types';
import PageHeaderText from 'components/base/page-header-text';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import useBaseAddonCategoryXlsContext from 'contexts/base-addon-category-xls.context';
import BaseAddonCategoryXlsReviewItem from './xls-review-item';

const ReviewBaseAddonCategory = () => {
  const navigate = useNavigate();
  const { mappedAddons, setMappedAddons, reviewedAddons, setReviewedAddons } =
    useBaseAddonCategoryXlsContext();
  const [openAddons, setOpenAddons] = useState<(string | undefined)[]>([]);

  const toggleAccordion = (idx: string) => {
    const addonExists = openAddons.find((i) => i === idx);
    if (addonExists) {
      setOpenAddons(openAddons?.filter((i) => i !== idx));
    } else {
      setOpenAddons([...openAddons, idx]);
    }
  };

  const handleReviewClick = (addon: BaseAddonCategoryXlsType | undefined, idx: string) => {
    if (addon) {
      if (addon?.hasError) return;
      setReviewedAddons([...reviewedAddons, idx]);
    }
  };

  const updateAddonData = (
    addon: BaseAddonCategoryXlsType,
    type: BaseAddonCategoryFormType,
    e: any,
    fieldType: BaseAddonCategoryFormFieldType,
    selection_type?: string
  ) => {
    if (type === 'dropdown' && fieldType === 'selection_type' && selection_type) {
      addon[fieldType] = selection_type;
    } else if (type === 'text') {
      const { value } = e.target;
      if (fieldType === 'ref') {
        addon[fieldType] = value.toUpperCase().replace(/\s/g, '');
      } else {
        addon[fieldType] = value;
      }
    }
  };

  const updateAddon = (
    i: number,
    type: BaseAddonCategoryFormType,
    e: any,
    fieldType: BaseAddonCategoryFormFieldType,
    selection_type?: string
  ) => {
    const addon = mappedAddons[i];
    if (!addon) return;
    updateAddonData(addon, type, e, fieldType, selection_type);
    toggleAddonError(addon);
    setMappedAddons([...mappedAddons]);
  };

  const addonHasError = (addon: BaseAddonCategoryXlsType) => {
    return !addon.name || !addon.ref || !addon.selection_type;
  };

  const toggleAddonError = (addon: BaseAddonCategoryXlsType) => {
    if (addonHasError(addon)) {
      addon.hasError = true;
    } else {
      addon.hasError = false;
    }
  };

  useEffect(() => {
    if (mappedAddons.length != 0) {
      setOpenAddons(mappedAddons?.map((_, i) => String(i)));
    }
  }, []);

  useEffect(() => {
    if (!mappedAddons || !mappedAddons?.length) {
      navigate(
        `${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS}/${ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS_UPLOAD}`
      );
    }
  }, []);

  return (
    <div>
      <PageHeaderText
        title='Item details'
        description='Review and confirm uploaded items'
        tagText={`${mappedAddons?.length} ${mappedAddons?.length === 1 ? 'item' : 'items'} found`}
      />

      <div className='space-y-10'>
        {mappedAddons?.map((addon, i) => (
          <BaseAddonCategoryXlsReviewItem
            addonIndex={i}
            key={i}
            addon={addon as Partial<BaseAddonCategoryXlsType>}
            isReview={reviewedAddons.includes(String(i) ?? '')}
            handleReviewClick={() => handleReviewClick(addon, String(i))}
            toggleAccordion={() => toggleAccordion(String(i))}
            show={openAddons.includes(String(i))}
            updateAddon={updateAddon}
          />
        ))}
      </div>
    </div>
  );
};

export default ReviewBaseAddonCategory;
